var PES = PES || {};

PES.DesktopNavigation = function () {

    function showNewUserRespect() {
        let userCreated = localStorage.getItem('userCreated');
        if (userCreated === 'true') {
            $('.js-account-created-message').show();
            localStorage.removeItem('userCreated');
        }
    }

    function manageDropdown() {
        let mainNavContainer = '.site-nav';
        let hasDropdown = '.main-btn[data-has-dropdown]';
        let submenu = $('div[data-menu-open]');

        $(hasDropdown).on('click', function (e) {
            let targetSubmenu = $(this).attr('data-has-dropdown');

            $(hasDropdown).not($(this)).removeClass('active');
            $(this).toggleClass('active');

            $(submenu).each(function () {
                if ($(this).hasClass(targetSubmenu)) {
                    $(this).attr('data-menu-open', true);
                } else {
                    $(this).attr('data-menu-open', false);
                }
            })
        });

        $(document).on('click', function (e) {
            var target = e.target;

            if (!$(target).closest(mainNavContainer).length
                || (!$(target).closest('.main-btn.active').length && !$(target).closest('div[data-menu-open]').length)) {
                $(hasDropdown).removeClass('active');
                $(submenu).attr('data-menu-open', false);
            }
        });

        $(document).on('keydown', function (event) {
            let openedDropdowns = $(submenu).filter(function () {
                return $(this).attr('data-menu-open') === 'true';
            })

            if (event.key === "Escape" && openedDropdowns.length) {
                $(hasDropdown).removeClass('active').blur();
                $(submenu).attr('data-menu-open', false);
            }
        });
    }

    var init = function () {
        showNewUserRespect();
        manageDropdown();
    };

    return {
        init: init
    };
}();